// Dlaždice "Sales, minulý týden" na Přehledu ownera a manažera (mockup v8, obrazovka 11).
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { PhoneCall, ArrowUpRight } from "lucide-react";
import { KartaPrehledu, HlavickaDlazdice, MrizkaDlazdic, MiniDlazdice, AkceHlavicky } from "../PrehledDlazdice.jsx";
import { salesGet, dm } from "./salesApi.js";
import { Pil } from "./salesUi.jsx";

export default function DlazdiceSales() {
  const navigate = useNavigate();
  const [d, setD] = useState(null);
  const [chyba, setChyba] = useState(false);
  // Neplatná odpověď (výpadek, jiný tvar) nesmí shodit celý Přehled, dlaždice se pak nekreslí.
  useEffect(() => { salesGet("prehled").then((x) => (x && x.obdobi ? setD(x) : setChyba(true))).catch(() => setChyba(true)); }, []);
  if (chyba) return null;
  return (
    <KartaPrehledu>
      <HlavickaDlazdice ikona={PhoneCall} nazev="Sales, minulý týden" podtitulek={d ? `${dm(d.obdobi.od)} až ${dm(d.obdobi.do)}` : ""}
        napoveda="Nové kontakty, domluvené zkušební tréninky a nové klientky za minulý týden. Detail je v Sales reportu."
        odznak="Live" odznakZivy
        akce={<AkceHlavicky ikona={ArrowUpRight} popis="Otevřít Sales report" onClick={() => navigate("/sales/report")} />} />
      <div className="p-3 sm:p-4">
        {!d ? <div className="h-20 animate-pulse rounded-xl bg-brand-light" /> : (
          <div className="space-y-3">
            <MrizkaDlazdic sloupce="grid-cols-3">
              <MiniDlazdice velka hodnota={d.kontakty} popisek="kontaktů" />
              <MiniDlazdice velka hodnota={d.zkusebni} popisek="zkušebních" ton="zelena" />
              <MiniDlazdice velka hodnota={d.klientky} popisek="klientek" ton="zelena" />
            </MrizkaDlazdic>
            <div className="flex flex-wrap gap-1.5">
              <Pil ton="neutralni" casti={["dovoláno", d.dovolanoPct == null ? "?" : `${d.dovolanoPct} %`]} />
              <Pil ton="neutralni" casti={["kontakt → zkušební", d.kontaktZkusebniPct == null ? "?" : `${d.kontaktZkusebniPct} %`]} />
              {d.cekajiNaPrvniHovor > 0 && <Pil ton="pozor" casti={["čeká na 1. hovor", String(d.cekajiNaPrvniHovor)]} />}
            </div>
          </div>
        )}
      </div>
    </KartaPrehledu>
  );
}
